import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import CropperDialog from '@pt/components/cropper-dialog/index.vue';
import { transBase64FromImageUrl } from '@/utils/index.js';
import { uploadFile } from '@/api/common/upload';
import { mapState, mapMutations } from 'vuex';
import resourceMixin from '@/views/creative/mixin/resource';
import { getFileName, isJpg, isPng } from '@com/utils/file';
import { getFilterConfigForFilter } from '@/store/creative/common/resource';
import filter from '@com/image/filter';
import { removeBase64Prefix } from '@com/utils/base64';
import categoryMixin from '@/views/creative/mixin/category';

export default {
  mixins: [resourceMixin, categoryMixin],
  components: {
    CropperDialog: CropperDialog
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    buttonAttrs: {
      type: Object
    }
  },
  data: function data() {
    return {
      cropperDialogVisible: false,
      cropper: {},
      loading: false
    };
  },

  watch: {
    cropperDialogVisible: function cropperDialogVisible(val) {
      var _this = this;

      if (val) {
        this.setEditResourceDialogClosable(false);
      } else {
        setTimeout(function () {
          _this.setEditResourceDialogClosable(true);
        }, 0);
      }
    }
  },
  computed: _extends({}, mapState({
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    },
    permissionKeys: function permissionKeys(state) {
      return state.creative.template.permissions;
    },
    template: function template(state) {
      return state.creative.template;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    },
    isCreativeTemplateCustom: function isCreativeTemplateCustom(state) {
      return state.creative.template.isCreativeTemplateCustom;
    }
  }), {
    innerButtonAttrs: function innerButtonAttrs() {
      return _extends({
        text: this.$t('playTurbo.custom.resourceDialog.handlerRelated.edit')
      }, this.buttonAttrs, {
        disabled: !this.isUpdatable
      });
    },
    isUpdatable: function isUpdatable() {
      if (this.hasPermission({ key: 'resource.basic-resource-updatable' })) {
        return true;
      }
      if (this.isModel && this.hasMvPlayable) {
        return true;
      }
      return this.resource && this.resource.is_basic !== 1;
    }
  }),
  methods: _extends({}, mapMutations({
    setEditResourceDialogClosable: 'creative/template/setEditResourceDialogClosable',
    showModelEditor: 'creative/modelEditor/showModelEditor',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateResourceManagerDialog: 'creative/asset/updateResourceManagerDialog'
  }), {
    uploadFile: uploadFile,

    openCropper: function openCropper() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var fileUrl, img, outputType;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                // 裁切组件应该用原始图片
                fileUrl = _this2.resource.extra.origin_file_url;
                _context.next = 4;
                return transBase64FromImageUrl(fileUrl);

              case 4:
                img = _context.sent;
                outputType = fileUrl.split('.')[fileUrl.split('.').length - 1].indexOf('png') === -1 ? 'jpeg' : 'png';

                _this2.cropper = {
                  img: img,
                  outputType: outputType
                };
                if (_this2.resourceMetaData) {
                  _this2.cropper = _extends({}, _this2.cropper, {
                    autoCropWidth: _this2.resourceMetaData.width,
                    autoCropHeight: _this2.resourceMetaData.height
                  });
                }
                _this2.cropperDialogVisible = true;
                _this2.loading = false;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var _this3 = this;

      var file = _ref.file;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var file_path, md5, url, newResource, isImage, filters, originalUrl, urls, res, _res$data$data, _file_path, _md, _url;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // eslint-disable-next-line camelcase
                file_path = file.file_path, md5 = file.md5, url = file.url;
                newResource = _extends({}, _this3.resource, {
                  file_path: file_path,
                  file_md5: md5,
                  file_url: url,
                  extra: _extends({}, _this3.resource.extra, {
                    // 图片裁切后需要将原始链接更换
                    origin_file_url: url
                  })
                });
                isImage = isPng(newResource.file_url) || isJpg(newResource.file_url);
                // 如果是图片，则补上滤镜处理

                if (!isImage) {
                  _context2.next = 14;
                  break;
                }

                filters = getFilterConfigForFilter(newResource.extra.config.filters, newResource.extra.config.enableFillColor);
                originalUrl = newResource.extra.origin_file_url;
                _context2.next = 8;
                return filter({
                  urls: [originalUrl],
                  filters: filters
                });

              case 8:
                urls = _context2.sent;
                _context2.next = 11;
                return uploadFile({
                  file_base64: removeBase64Prefix(urls[0]),
                  filename: getFileName(originalUrl),
                  quality: 70
                });

              case 11:
                res = _context2.sent;
                _res$data$data = res.data.data, _file_path = _res$data$data.file_path, _md = _res$data$data.md5, _url = _res$data$data.url;

                newResource = _extends({}, newResource, {
                  file_path: _file_path,
                  file_md5: _md,
                  file_url: _url
                });

              case 14:
                _context2.next = 16;
                return _this3.$store.dispatch('creative/template/updateResource', newResource);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    openModelEditor: function openModelEditor() {
      // 如果页面已经打开资源弹框，编辑页面如需打开资源弹框将出现层架问题，故打开模型编辑时需关闭弹框
      this.updateResourceManagerDialog({
        visible: false
      });
      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(this.resource);
      this.showModelEditor({
        modelPath: this.resource.real_file_path
      });
    }
  })
};